import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducers from '../reducers';

import { initStateCategoriesDocuments } from '../dataState/categories_documents';
import { initStateTypeDocuments } from '../dataState/type_documents';
import { initStateCustomers } from '../dataState/customers';
import { initStateGeneralConcepts } from '../dataState/general_concepts';
import { initStateConcepts } from '../dataState/concepts';
import { initStateCategories } from '../dataState/categories';
import { initStateCatalogueTypeDocuments } from '../dataState/catalogue_type_documents';
import { initStateEnterprise } from '../dataState/enterprise';
import { initStateBankFee } from '../dataState/bank_fee';
import { initStateBankTaxes } from '../dataState/bank_taxes';
import { initStateUser } from '../dataState/user';
import { initStateIsabi } from '../dataState/isabi_taxes';
import { initStateConceptsDiscount } from '../dataState/concepts_discount';
import { initStatePaymentsBudgets } from '../dataState/payments_budgets';
import { initStateDashboard } from '../dataState/dashboard';

const initialState = {
   categories_documents     : initStateCategoriesDocuments,
   type_documents           : initStateTypeDocuments,
   customers                : initStateCustomers,
   general_concepts         : initStateGeneralConcepts,
   concepts                 : initStateConcepts,
   categories               : initStateCategories,
   catalogue_type_documents : initStateCatalogueTypeDocuments,
   enterprise               : initStateEnterprise,
   bank_fees                : initStateBankFee,
   bank_taxes               : initStateBankTaxes,
   user                     : initStateUser,
   isabi_taxes              : initStateIsabi,
   concepts_discount        : initStateConceptsDiscount,
   payments_budgets         : initStatePaymentsBudgets,
   dashboard                : initStateDashboard
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore( reducers, initialState, composeEnhancers(applyMiddleware(thunk)));
